import { Link } from "react-router-dom";
import { useState } from "react";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <header
      className="header-area header-sticky wow slideInDown"
      data-wow-duration="0.75s"
      data-wow-delay="0s"
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            <nav className="main-nav">
              <a href="/" className="logo">
                <img
                  alt="logo"
                  src="assets/images/ACT-Gray.png"
                  style={{
                    width: 100,
                  }}
                />
              </a>

              <ul className="nav">
                <li className="scroll-to-section">
                  <a href="/events" className="active">
                    Home
                  </a>
                </li>
                <li className="scroll-to-section">
                  <a href="/#about">About Us</a>
                </li>
                <li className="scroll-to-section">
                  <Link to="/agenda">Agenda</Link>
                </li>
                <li className="scroll-to-section">
                  <Link to="/hotel">Hotel</Link>
                </li>
                <li className="scroll-to-section">
                  <div className="be-sponsor">
                    <Link to="/sponsor">Be a Sponsor</Link>
                  </div>
                </li>
                <li className="scroll-to-section">
                  <div className="main-red-button">
                    <a href="/register">Register Now</a>
                  </div>
                </li>
              </ul>
              <a
                className={`menu-trigger hamburger ${menuOpen ? "active" : ""}`}
                onClick={() => setMenuOpen(!menuOpen)}
              >
                <span>Menu</span>
              </a>
            </nav>
          </div>

          <div className={`mobile-menu text-start ${menuOpen ? "open" : ""}`}>
            <ul>
              <li onClick={() => setMenuOpen(false)}>
                <a href="#top">Home</a>
              </li>
              <li onClick={() => setMenuOpen(false)}>
                <a href="/#about">About Us</a>
              </li>
              <li onClick={() => setMenuOpen(false)}>
                <Link to="/agenda">Agenda</Link>
              </li>
              <li onClick={() => setMenuOpen(false)}>
                <Link to="/hotel">Hotel</Link>
              </li>
              <li onClick={() => setMenuOpen(false)}>
                <Link to="/sponsor">Be a Sponsor</Link>
              </li>
              <li onClick={() => setMenuOpen(false)}>
                <a href="/register" className="btn-register">
                  Register Now
                </a>
              </li>
            </ul>
          </div>
          {menuOpen && (
            <div className="overlay" onClick={() => setMenuOpen(false)}></div>
          )}
        </div>
      </div>
      {/* <div id="js-preloader" className="js-preloader">
        <div className="preloader-inner">
          <span className="dot"></span>
          <div className="dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div> */}
    </header>
  );
}
